import { render, staticRenderFns } from "./ScoutTabScouted.vue?vue&type=template&id=450a1f8c"
import script from "./ScoutTabScouted.vue?vue&type=script&lang=js"
export * from "./ScoutTabScouted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports